const baseColormap = {
	'black': '#1a1a1a',
	'gray-dark-4': '#292929',
	'gray-dark-3': '#343537',
	'gray-dark-2': '#4f5051',
	'gray-dark-1': '#6a6b6c',
	'gray-base': '#858688',
	'gray-light-1': '#aeaeaf',
	'gray-light-2': '#d7d7d8',
	'gray-light-3': '#ebebec',
	'gray-light-4': '#f5f5f6',
	'white': '#fff',
	'primary-darker': '#0387b8',
	'primary-dark': '#0393c9',
	'primary-base': '#07c1e4',
	'primary-light': '#66c5e8',
	'primary-lighter': '#c5e9f7',
	'people-darker': '#118e7c',
	'people-dark': '#129b87',
	'people-base': '#14a792',
	'people-light': '#6ec9bc',
	'people-lighter': '#c9ebe6',
	'meetings-darker': '#c65919',
	'meetings-dark': '#d8611b',
	'meetings-base': '#e9691e',
	'meetings-light': '#f2a374',
	'meetings-lighter': '#faddcb',
	'negative-darker': '#d03d35',
	'negative-dark': '#e3423a',
	'negative-base': '#f5483f',
	'negative-light': '#f98e89',
	'negative-lighter': '#fdd5d3',
	'cta-darker': '#398f38',
	'cta-dark': '#3e9d3d',
	'cta-base': '#43a942',
	'cta-light': '#8bca8a',
	'cta-lighter': '#d4ecd4',
	'attention-darker': '#d08d1d',
	'attention-dark': '#e39a20',
	'attention-base': '#f5a623',
	'attention-light': '#f9c877',
	'attention-lighter': '#fdebcd',
	'alerts-darker': '#d35545',
	'alerts-dark': '#e25a4b',
	'alerts-base': '#f96452',
	'alerts-light': '#fc9f94',
	'alerts-lighter': '#fedcd7',

	/* base colors as per badges, these colors are subject to change and also in shades */
	'info-base': '#00d6a2',
	'success-base': '#30d557',
	'warning-base': '#ffb400',
	'danger-base': '#ff513d',

	/* latest colors */
	'blue': '#0AB7D7',
	'blue-light': '#6CD3E7',
	'blue-dark': '#09AFCE',
	'blue-darker': '#09A8C6',
	'mint': '#0AC391',
	'mint-light': '#6CDBBD',
	'mint-dark': '#09BB8B',
	'mint-darker': '#09B385',
	'orange': '#E86935',
	'orange-light': '#F1A585',
	'orange-dark': '#E66531',
	'orange-darker': '#DD612F',
	'red': '#E74A3E',
	'red-light': '#F0928B',
	'red-dark': '#E2493D',
	'red-darker': '#D9463A',
	'green': '#32C655',
	'green-light': '#84DC99',
	'green-dark': '#30BE51',
	'green-darker': '#2EB64E',
	'yellow': '#F0A309',
	'yellow-light': '#F6C76B',
	'yellow-dark': '#E69C08',
	'yellow-darker': '#DD9608',
	'pink': '#E03A63',
	'pink-light': '#EC88A1',
	'pink-dark': '#DC3A62',
	'pink-darker': '#D3385E',
	'purple': '#BC4BC4',
	'purple-light': '#D693DB',
	'purple-dark': '#B73FC0',
	'purple-darker': '#B03CB8',
	'violet': '#8F65E0',
	'violet-light': '#BBA2EC',
	'violet-dark': '#8961D7',
	'violet-darker': '#835DCE',
	'cyan': '#08AEBE',
	'cyan-light': '#6ACED8',
	'cyan-dark': '#07A7B6',
	'cyan-darker': '#07A0AF'

};

const colormap = Object.assign(baseColormap, {
	'eggplant-base': baseColormap['alerts-base'],
	'primary': baseColormap['primary-base'],
	'people': baseColormap['people-base'],
	'meetings': baseColormap['meetings-base'],
	'eggplant': baseColormap['alerts-base'],
	'negative': baseColormap['negative-base'],
	'cta': baseColormap['cta-base'],
	'attention': baseColormap['attention-base'],
	'alerts': baseColormap['alerts-base'],
	'primary-color': baseColormap['primary-base'],
	'secondary-color': baseColormap['gray-base'],
	'alerts-color': baseColormap['alerts-base'],
	'alert-color': baseColormap['alerts-base'],
	'cta-color': baseColormap['cta-base'],
	'success-color': baseColormap['cta-base'],
	'attention-color': baseColormap['attention-base'],
	'warning-color': baseColormap['attention-base'],
	'people-color': baseColormap['people-base'],
	'info-color': baseColormap['people-base'],
	'meetings-color': baseColormap['meetings-base'],
	'negative-color': baseColormap['negative-base'],
	'gray-darkest': baseColormap['gray-dark-4'],
	'gray-darker': baseColormap['gray-dark-2'],
	'gray-dark': baseColormap['gray-dark-1'],
	'gray': baseColormap['gray-base'],
	'gray-light': baseColormap['gray-light-2'],
	'gray-lighter': baseColormap['gray-light-2'],
	'gray-lightest': baseColormap['gray-light-4'],
	'brand-white': baseColormap['white'],
	'brand-primary': baseColormap['primary-base'],
	'brand-primary-light': baseColormap['primary-light'],
	'brand-primary-dark': baseColormap['primary-dark'],
	'brand-primary-darker': baseColormap['primary-darker'],
	'brand-success': baseColormap['cta-base'],
	'brand-success-light': baseColormap['cta-light'],
	'brand-success-dark': baseColormap['cta-dark'],
	'brand-success-darker': baseColormap['cta-darker'],
	'brand-info-light': baseColormap['people-light'],
	'brand-info': baseColormap['people-base'],
	'brand-info-dark': baseColormap['people-dark'],
	'brand-info-darker': baseColormap['people-darker'],
	'brand-warning': baseColormap['attention-base'],
	'brand-warning-light': baseColormap['attention-light'],
	'brand-warning-dark': baseColormap['attention-dark'],
	'brand-warning-darker': baseColormap['attention-darker'],
	'brand-danger': baseColormap['negative-base'],
	'brand-danger-light': baseColormap['negative-light'],
	'brand-danger-dark': baseColormap['negative-dark'],
	'brand-danger-darker': baseColormap['negative-darker']
});

export default colormap;
